import { programmeTypes } from '@constants/index';

export const getIsNonOfflineHybridCourse = (course) =>
  course?.courseType === programmeTypes.HYBRID_NON_OFFLINE;

export const getIsOnlyRecordedClassesPresent = (course) =>
  getIsNonOfflineHybridCourse(course) &&
  (course?.isRecordedClassesOnlyCourse ||
    !course?.programme?.isLiveClassPresent);
